import { useCallback, useContext, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { removeProgress } from '../../../../../../store/slices/dashboardSlice/action';
import {
    dashboardActions,
    progressSelector,
} from '../../../../../../store/slices/dashboardSlice/dashboardSlice';
import { ProgressContext } from '../../../../Context/ProgressContext';

export const useDropdown = (fileId: string) => {
    const dispatch = useDispatch();

    const { activeMassSelectModeHandle, onSelectedMassMediaIds } = useContext(ProgressContext);

    const [isShowPopup, setIsShowPopup] = useState(false);

    const { original_url, video_url } = useSelector((state) =>
        progressSelector.selectById(state, fileId)
    );

    const onEdit = useCallback(() => {
        dispatch(dashboardActions.changeCurrentProgressId(+fileId));
    }, []);

    const onSelect = useCallback(() => {
        activeMassSelectModeHandle(true);
        onSelectedMassMediaIds(fileId);
    }, []);

    const onShowDelete = useCallback(() => {
        setIsShowPopup(true);
    }, []);

    const onDelete = useCallback(() => {
        dispatch(removeProgress(+fileId));
        setIsShowPopup(false);
    }, []);

    const onHidePopup = useCallback(() => {
        setIsShowPopup(false);
    }, []);

    return {
        onEdit,
        onDelete,
        original_url,
        video_url,
        isShowPopup,
        onShowDelete,
        onHidePopup,
        onSelect,
    };
};
